import toast from "react-hot-toast";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { BASE_URL_FLASK } from "../services/serviceUrls";
import { log } from "three/src/nodes/TSL.js";

const Login = () => {
  const [formData, setFormData] = useState({ username: "", password: "" });
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const LoginUser = async (e) => {
    e.preventDefault();
    const { username, password } = formData;

    try {
      const response = await fetch(`${BASE_URL_FLASK}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, password }),
      });

      const responseData = await response.json();

      if (response.status === 200) {
        toast.success("Login successful!");

        // Store user data and token in localStorage
        localStorage.setItem("username", responseData.user.username);
        localStorage.setItem("access_token", responseData.access_token);
        localStorage.setItem("user_id", responseData.user.id);
        localStorage.setItem("user_role", responseData.user.role);
        navigate("/dashboard");
      } else if (response.status === 401) {
        toast.error(responseData.error || "Invalid credentials");
      } else if (response.status === 400) {
        toast.error(responseData.error || "Please provide valid credentials");
      }
    } catch (error) {
      toast.error("An error occurred during login");
    }
  };

  return (
    <div className="h-screen flex items-center justify-center text-white bg-black">
      <div className="absolute w-[460px] h-[670px]">
        <div className="w-full h-full block border-2 border-[#1E1E1E] p-10 rounded-lg shadow-lg bg-black-100">
          <div className="flex justify-center">
            <img
              src="/logo.svg"
              className="object-cover w-40"
              alt="altroverse"
            />
          </div>
          <div className="flex gap-3">
            <h2 className="mb-4 mt-8 text-3xl font-semibold flex items-center justify-center">
              LOG INTO YOUR
            </h2>
            <h2 className="mb-4 mt-8 text-3xl text-[#FF9900] font-semibold flex items-center justify-center">
              ACCOUNT
            </h2>
          </div>
          <form onSubmit={LoginUser}>
            <div className="form-group mb-6 mt-10">
              <label className="form-label inline-block mb-2 text-gray-300 font-semibold">
                Email / Username
              </label>
              <input
                onChange={handleChange}
                type="text"
                name="username"
                placeholder="Email"
                value={formData.username}
                className={inputStyle}
                autoComplete="email"
              />
            </div>
            <div className="form-group mb-2">
              <label className="form-label inline-block mb-2 text-gray-300 font-semibold">
                Password
              </label>
              <input
                onChange={handleChange}
                type="password"
                name="password"
                placeholder="Password"
                value={formData.password}
                className={inputStyle}
                autoComplete="current-password"
              />
            </div>
            <br />
            <button
              type="submit"
              className="px-6 py-4 w-full font-bold text-md text-black bg-[#FF9900] leading-tight rounded-full uppercase hover:bg-[#cf7d02] shadow-md hover:shadow-lg transition duration-150"
            >
              Login
            </button>
          </form>
          <br />
        </div>
      </div>
    </div>
  );
};

export default Login;

const inputStyle =
  "form-control block w-full px-3 py-1.5 text-base font-normal text-gray-300 bg-[#121212] bg-clip-padding rounded transition ease-in-out m-0 focus:text-gray-300 focus:border-blue-600 focus:outline-none";
